// SVG logo: minimalist key whose bit morphs into a shield.
// Used at multiple sizes (nav 32px, hero 56px).
export function Logo({ size = 32, className = "", withWordmark = false }) {
    const s = size;
    return (
        <span className={`inline-flex items-center gap-2 ${className}`}>
            <svg
                width={s}
                height={s}
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                role="img"
            >
                {/* Shield backdrop */}
                <path
                    d="M24 3 L42 8 V22 C42 33 34 42 24 45 C14 42 6 33 6 22 V8 L24 3 Z"
                    fill="#E7EFED"
                    stroke="#2A5A5B"
                    strokeWidth="1.6"
                    strokeLinejoin="round"
                />
                {/* Key head — clean circle */}
                <circle cx="24" cy="17" r="5.2" fill="#2A5A5B" />
                <circle cx="24" cy="17" r="1.9" fill="#F4F7F6" />
                {/* Key shaft */}
                <rect x="22.7" y="21" width="2.6" height="12" rx="1" fill="#2A5A5B" />
                {/* Key bit teeth morphing into shield notch */}
                <path
                    d="M25.3 27 H30 V29.5 H27 V32 H25.3 Z"
                    fill="#D87F61"
                />
                <path
                    d="M25.3 32 H28.2 V34.2 H25.3 Z"
                    fill="#D87F61"
                />
            </svg>
            {withWordmark && (
                <span className="font-heading font-bold tracking-tight text-shield-ink leading-none">
                    Letzter<span className="text-shield-terracotta">·</span>Schlüssel
                </span>
            )}
        </span>
    );
}

export default Logo;
